import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { ListRolesSchema, Module } from '@app/models/users';
import { useLocalSelector } from '@app/services/hooks/useRedux';

export const useRoleModuleCaption = (): ((role: Pick<ListRolesSchema, 'module'>) => string | undefined) => {
  const canViewWarehouses = useLocalSelector(
    (state) => !!state.currentSession.warehousesContext?.scope?.$permissions?.view_warehouses
  );
  const spaceT = useTranslation(NSKeys.spaceSettings);
  const commonT = useTranslation(NSKeys.common);

  return useCallback(
    ({ module: roleModule }: Pick<ListRolesSchema, 'module'>) =>
      roleModule && !(roleModule === Module.Warehouse && canViewWarehouses)
        ? spaceT.t('roleModuleRequired', { module: commonT.t(`module.${roleModule}` as const) })
        : undefined,
    [canViewWarehouses, spaceT.t, commonT.t]
  );
};
